import Box from '@mui/material/Box'
import { styled } from '@mui/system'

interface SlideMenuBoxProps {
	readonly minimize?: boolean
}

const SlideMenuBox = styled(Box, {
	shouldForwardProp: props => props !== 'open',
})<SlideMenuBoxProps>(({ theme, minimize }) => ({
	flexGrow: 1,
	display: 'flex',
	flexDirection: 'column',
	backgroundColor: theme.palette.common.white,
	borderRadius: '1.875rem 0 0 0',
	boxShadow: '0 3px 50px 0 rgba(0, 0, 0, 0.2)',
	borderRight: `0.0625rem solid ${theme.palette.grey[200]}`,
	zIndex: 1000,
	position: 'absolute',
	top: 0,
	right: 0,
	bottom: 0,
	left: 0,
	width: minimize ? '20.75rem' : '5.625rem',
	transition: '0.5s',
	padding: minimize
		? '2.125rem 0.625rem'
		: '2.125rem 1.0625rem 2.125rem 1.125rem',
}))

export { SlideMenuBox }
